import { useContext, useState } from "react";
import DropdownCore from "./components/DropdownCore";
import DropdownItem from "./components/DropdownItem";
import { BsPerson, BsLock, BsCaretDown } from "react-icons/bs";
import modalContext from "../../../dataManager/context/modalContext";
import { saveProduct } from "../../../../src/api/users/usersApi";
import currentAdminContext from "../../../dataManager/context/currentAdminContext";
import { toast } from "react-toastify";
import Paragraph from "../../elements/p/Paragraph";

const ProfileAdminDropdown = ({ productId, onChangeLoading }) => {
  //context variables
  const { currentAdmin } = useContext(currentAdminContext);
  const { handleOpenModal } = useContext(modalContext);

  const [error, setError] = useState(false);

  const handleSaveProduct = async () => {
    onChangeLoading(true);
    setError("");
    try {
      const { data, error } = await saveProduct(currentAdmin, productId);

      if (data) {
        toast.success("L'article a été enregistré, vérifier votre profile", {
          theme: "colored",
        });
        setError("");
        return onChangeLoading(false);
      }

      toast.info("Cet article est déjà enregistré sur votre profile", {
        theme: "colored",
      });
      setError("");
      return onChangeLoading(false);
    } catch (error) {
      setError(error);
      onChangeLoading(false);
    }
  };

  const buttonOpenModal = (
    <div className="flex items-center space-x-1 rounded-full border border-secondary py-1 px-2.5 text-start text-secondary">
      <Paragraph size="small">Modifier</Paragraph> <BsCaretDown size={16} />{" "}
    </div>
  );

  return (
    <DropdownCore buttonOpenModal={buttonOpenModal}>
      <DropdownItem
        icon={<BsLock size={16} />}
        title="Mot de pass"
        onClick={() =>
          handleOpenModal("UPDATE_PASSWORD_ADMIN", "Modifier votre mot de pass")
        }
      />
      <DropdownItem
        icon={<BsPerson size={18} />}
        title="votre profile"
        onClick={() =>
          handleOpenModal("EDIT_ADMIN", "Modifier votre profile", {
            adminId: currentAdmin.getId,
          })
        }
      />
    </DropdownCore>
  );
};

export default ProfileAdminDropdown;
